import './index.less';

import FAdd from './FAdd';
import FApply from './FApply';
import FArrow from './FArrow';
import FArrowDown from './FArrowDown';
import FArrowRight from './FArrowRight';
import FBinding from './FBinding';
import FCancelCollect from './FCancelCollect';
import FCheck from './FCheck';
import FCheckMark from './FCheckMark';
import FCircleDelete from './FCircleDelete';
import FCircleEdit from './FCircleEdit';
import FClose from './FClose';
import FCloudUpload from './FCloudUpload';
import FCode from './FCode';
import FCollect from './FCollect';
import FComposition from './FComposition';
import FConfiguration from './FConfiguration';
import FContent from './FContent';
import FContract from './FContract';
import FCopy from './FCopy';
import FCreate from './FCreate';
import FDecrease from './FDecrease';
import FDelete from './FDelete';
import FDoubleDown from './FDoubleDown';
import FDoubleUp from './FDoubleUp';
import FDown from './FDown';
import FDownload from './FDownload';
import FDrag from './FDrag';
import FEdit from './FEdit';
import FExclamation from './FExclamation';
import FExit from './FExit';
import FExport from './FExport';
import FFail from './FFail';
import FFavorite from './FFavorite';
import FFeather from './FFeather';
import FFileSearch from './FFileSearch';
import FFileText from './FFileText';
import FForbid from './FForbid';
import FFreelog from './FFreelog';
import FFullScreen from './FFullScreen';
import FGuideDown from './FGuideDown';
import FImport from './FImport';
import FIncrease from './FIncrease';
import FInfo from './FInfo';
import FLeft from './FLeft';
import FLine from './FLine';
import FLinkedin from './FLinkedin';
import FLoading from './FLoading';
import FLocalUpload from './FLocalUpload';
import FLock from './FLock';
import FLoudspeaker from './FLoudspeaker';
import FMappingRuleActive from './FMappingRuleActive';
import FMappingRuleAdd from './FMappingRuleAdd';
import FMappingRuleAttr from './FMappingRuleAttr';
import FMappingRuleCover from './FMappingRuleCover';
import FMappingRuleLabel from './FMappingRuleLabel';
import FMappingRuleOffline from './FMappingRuleOffline';
import FMappingRuleOnline from './FMappingRuleOnline';
import FMappingRuleReplace from './FMappingRuleReplace';
import FMappingRuleTitle from './FMappingRuleTitle';
import FMappingRuleVersion from './FMappingRuleVersion';
import FNavigate from './FNavigate';
import FNodes from './FNodes';
import FObject from './FObject';
import FPaperPlane from './FPaperPlane';
import FPentacle from './FPentacle';
import FPentagram from './FPentagram';
import FPlayer from './FPlayer';
import FPlus from './FPlus';
import FPolicy from './FPolicy';
import FProperty from './FProperty';
import FRedo from './FRedo';
import FResource from './FResource';
import FResourceFile from './FResourceFile';
import FRight from './FRight';
import FRotate from './FRotate';
import FSafetyLock from './FSafetyLock';
import FSetting from './FSetting';
import FShare from './FShare';
import FSina from './FSina';
import FStorageSpace from './FStorageSpace';
import FSwap from './FSwap';
import FThickArrowRight from './FThickArrowRight';
import FUnbinding from './FUnbinding';
import FUp from './FUp';
import FUpcast from './FUpcast';
import FUpdate from './FUpdate';
import FUpdateVersion from './FUpdateVersion';
import FUser from './FUser';
import FWarning from './FWarning';
import FWeChat from './FWeChat';

export default class FIcons {
  public static FAdd = FAdd;
  public static FApply = FApply;
  public static FArrow = FArrow;
  public static FArrowDown = FArrowDown;
  public static FArrowRight = FArrowRight;
  public static FBinding = FBinding;
  public static FCancelCollect = FCancelCollect;
  public static FCheck = FCheck;
  public static FCheckMark = FCheckMark;
  public static FCircleDelete = FCircleDelete;
  public static FCircleEdit = FCircleEdit;
  public static FClose = FClose;
  public static FCloudUpload = FCloudUpload;
  public static FCode = FCode;
  public static FCollect = FCollect;
  public static FComposition = FComposition;
  public static FConfiguration = FConfiguration;
  public static FContent = FContent;
  public static FContract = FContract;
  public static FCopy = FCopy;
  public static FCreate = FCreate;
  public static FDecrease = FDecrease;
  public static FDelete = FDelete;
  public static FDoubleDown = FDoubleDown;
  public static FDoubleUp = FDoubleUp;
  public static FDown = FDown;
  public static FDownload = FDownload;
  public static FDrag = FDrag;
  public static FEdit = FEdit;
  public static FExclamation = FExclamation;
  public static FExit = FExit;
  public static FExport = FExport;
  public static FFail = FFail;
  public static FFavorite = FFavorite;
  public static FFeather = FFeather;
  public static FFileSearch = FFileSearch;
  public static FFileText = FFileText;
  public static FForbid = FForbid;
  public static FFreelog = FFreelog;
  public static FFullScreen = FFullScreen;
  public static FGuideDown = FGuideDown;
  public static FImport = FImport;
  public static FIncrease = FIncrease;
  public static FInfo = FInfo;
  public static FLeft = FLeft;
  public static FLine = FLine;
  public static FLinkedin = FLinkedin;
  public static FLoading = FLoading;
  public static FLocalUpload = FLocalUpload;
  public static FLock = FLock;
  public static FLoudspeaker = FLoudspeaker;
  public static FMappingRuleActive = FMappingRuleActive;
  public static FMappingRuleAdd = FMappingRuleAdd;
  public static FMappingRuleAttr = FMappingRuleAttr;
  public static FMappingRuleCover = FMappingRuleCover;
  public static FMappingRuleLabel = FMappingRuleLabel;
  public static FMappingRuleOffline = FMappingRuleOffline;
  public static FMappingRuleOnline = FMappingRuleOnline;
  public static FMappingRuleReplace = FMappingRuleReplace;
  public static FMappingRuleTitle = FMappingRuleTitle;
  public static FMappingRuleVersion = FMappingRuleVersion;
  public static FNavigate = FNavigate;
  public static FNodes = FNodes;
  public static FObject = FObject;
  public static FPaperPlane = FPaperPlane;
  public static FPentacle = FPentacle;
  public static FPentagram = FPentagram;
  public static FPlayer = FPlayer;
  public static FPlus = FPlus;
  public static FPolicy = FPolicy;
  public static FProperty = FProperty;
  public static FRedo = FRedo;
  public static FResource = FResource;
  public static FResourceFile = FResourceFile;
  public static FRight = FRight;
  public static FRotate = FRotate;
  public static FSafetyLock = FSafetyLock;
  public static FSetting = FSetting;
  public static FShare = FShare;
  public static FSina = FSina;
  public static FStorageSpace = FStorageSpace;
  public static FSwap = FSwap;
  public static FThickArrowRight = FThickArrowRight;
  public static FUnbinding = FUnbinding;
  public static FUp = FUp;
  public static FUpcast = FUpcast;
  public static FUpdate = FUpdate;
  public static FUpdateVersion = FUpdateVersion;
  public static FUser = FUser;
  public static FWarning = FWarning;
  public static FWeChat = FWeChat;
};
